import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { selectTotalPotSize } from '../../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../../redux/store';
import { getSetBetActions } from '../../../../utils/setBetActionUtils';
import { isTestEnvironment } from '../../../../utils/utils';
import { SetBetButton } from './setBetButton';
const PIXI_DATA = isTestEnvironment() ? { type: 'set-bet-controls' } : null;
export const PixiSetBetButtonGroup = ({ myTurnProperties }) => {
    const setBetButtonGroupBounds = useAppSelector((state) => state.gameDimensions.setBetButtonGroupBounds, shallowEqual);
    const totalPotSize = useAppSelector(selectTotalPotSize);
    if (!setBetButtonGroupBounds) {
        return null;
    }
    const { betIncrement, betSliderMinAmount, betSliderMaxAmount, betTotalAmountToCall, myNumChipsThisPhase, myTotalBetAmount } = myTurnProperties;
    const getSetBetActionsObj = {
        betIncrement,
        betSliderMinAmount,
        betSliderMaxAmount,
        betTotalAmountToCall,
        myNumChipsThisPhase,
        myTotalBetAmount,
        totalPotSize
    };
    const setBetActions = getSetBetActions(getSetBetActionsObj);
    const betActionButtonW = Math.round(setBetButtonGroupBounds.w / setBetActions.length);
    return (_jsx(Container, { "pixi-data": PIXI_DATA, children: setBetActions.map((setBetAction, i) => {
            if (!setBetAction) {
                return null;
            }
            const bounds = {
                x: setBetButtonGroupBounds.x - setBetButtonGroupBounds.w / 2 + betActionButtonW / 2 + i * betActionButtonW,
                y: setBetButtonGroupBounds.y,
                w: betActionButtonW,
                h: setBetButtonGroupBounds.h
            };
            return _jsx(SetBetButton, { setBetAction: setBetAction, bounds: bounds }, i);
        }) }));
};
